var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1131_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6277 2.52563C9.83387 1.2903 8.60499 0.438463 7.16985 0.126945C5.73472 -0.184573 4.26414 0.0818289 3.02881 0.875663C2.80001 1.02283 2.73341 1.3279 2.88057 1.55671C3.02774 1.78551 3.33281 1.85211 3.56161 1.70495C4.57459 1.05291 5.78199 0.834843 6.95931 1.0905C8.13663 1.34616 9.14423 2.04547 9.79627 3.05844C11.1422 5.15098 10.5342 7.9482 8.44278 9.29417C7.42981 9.94621 6.22241 10.1643 5.04509 9.90861C3.86776 9.65295 2.85909 8.95365 2.20812 7.94068C1.20697 6.38309 1.25208 4.40011 2.32414 2.88979C2.48204 2.66743 2.42941 2.36021 2.20705 2.2023C1.98469 2.04439 1.67747 2.09703 1.51956 2.31939C0.213333 4.16057 0.158549 6.57644 1.37991 8.47456C2.17482 9.70989 3.40263 10.5617 4.83777 10.8732C5.22985 10.9581 5.62408 11 6.01509 11C7.05814 11 8.0797 10.7014 8.97773 10.1245C11.5268 8.48422 12.2669 5.07579 10.6277 2.52563Z",
    fill: "#FF5C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.32732 7.17238C4.42399 7.26905 4.54968 7.31632 4.67643 7.31632C4.80319 7.31632 4.92887 7.26798 5.02555 7.17238L6.00092 6.197L6.97629 7.17238C7.07297 7.26905 7.19865 7.31632 7.32541 7.31632C7.45217 7.31632 7.57785 7.26798 7.67453 7.17238C7.86681 6.98009 7.86681 6.6675 7.67453 6.47522L6.697 5.49985L7.67238 4.52447C7.86466 4.33219 7.86466 4.0196 7.67238 3.82732C7.48009 3.63504 7.1675 3.63504 6.97522 3.82732L5.99985 4.80269L5.02447 3.82732C4.83219 3.63504 4.5196 3.63504 4.32732 3.82732C4.13504 4.0196 4.13504 4.33219 4.32732 4.52447L5.30269 5.49985L4.32732 6.47522C4.13504 6.6675 4.13504 6.97902 4.32732 7.17238Z",
    fill: "#FF5C00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1131_405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.3293abee51cc68b05a8c5084ae20db70.svg";
export { ForwardRef as ReactComponent };